import { http, onSuccess, onFail } from "./http";

// Blocks
export const getGlobalSettings = (eventPassword) => {
    return http
        .get(`/api/cp/event/${eventPassword}/emailSettings`)
        .then(onSuccess, onFail);
};

export const getBlocks = (eventKey) => {
    return http
        .get(`/api/cp/event/${eventKey}/emailMessageBlocks`)
        .then(onSuccess, onFail);
};

export const getBlockInfo = (block) => {
    return http
        .get(`/api/cp/event/emailMessageBlocks/${block}`)
        .then(onSuccess, onFail);
};

export const createBlock = (eventKey, payload) => {
    return http
        .post(`/api/cp/event/${eventKey}/emailMessageBlocks`, payload)
        .then(onSuccess, onFail);
};

export const editBlock = (payload) => {
    return http
        .post(`/api/cp/event/emailMessageBlocks/${payload.id}`, payload)
        .then(onSuccess, onFail);
};

export const deleteBlock = (blockId) => {
    return http
        .delete(`/api/cp/event/emailMessageBlocks/${blockId}`)
        .then(onSuccess, onFail);
};

export const previewBlock = (blockId) => {
    return http
        .get(`/api/cp/event/emailMessageBlocks/${blockId}/preview`)
        .then(onSuccess, onFail);
};

// NOT USED
export const getBlocksReferenceData = () => {
    return http
        .get("/api/cp/event/emailMessageBlocks/reference-data")
        .then(onSuccess, onFail);
};

// NOT USED
export const visitButtonLink = (token) => {
    return http
        .get(`/api/cp/event/emailMessageBlocks/link/${token}`)
        .then(onSuccess, onFail);
};

// Messages
export const getTemplates = (eventKey) => {
    return http
        .get(`/api/cp/event/${eventKey}/emailMessageTemplates`)
        .then(onSuccess, onFail);
};

export const templateDetails = (template) => {
    return http
        .get(`/api/cp/event/emailMessageTemplates/${template}`)
        .then(onSuccess, onFail);
};

export const createTemplate = (eventKey, payload) => {
    return http
        .post(`/api/cp/event/${eventKey}/emailMessageTemplates`, payload)
        .then(onSuccess, onFail);
};

export const editTemplate = (template, payload) => {
    return http
        .post(`/api/cp/event/emailMessageTemplates/${template}`, payload)
        .then(onSuccess, onFail);
};

export const deleteTemplate = (template) => {
    return http
        .delete(`/api/cp/event/emailMessageTemplates/${template}`)
        .then(onSuccess, onFail);
};

export const previewTemplate = (template) => {
    return http
        .get(`/api/cp/event/emailMessageTemplates/${template}/preview`)
        .then(onSuccess, onFail);
};

export const templateActions = (template, action) => {
    return http
        .patch(
            `/api/cp/event/emailMessageTemplates/${template}?action=${action}`
        )
        .then(onSuccess, onFail);
};

// Calendar Settings
export const getEventCalendarSettings = (eventPassword) => {
    return http
        .get(`/api/cp/event/${eventPassword}/emailSettingsCalendar`)
        .then(onSuccess, onFail);
};

export const updateEventCalendarSettings = (eventPassword, payload) => {
    return http
        .post(`/api/cp/event/${eventPassword}/emailSettingsCalendar`, payload)
        .then(onSuccess, onFail);
};

export const previewEventCalendarSettings = (
    eventPassword,
    participationType
) => {
    return http
        .get(
            `/api/cp/event/${eventPassword}/emailSettingsCalendar/${participationType}/preview`
        )
        .then(onSuccess, onFail);
};
